import { removerCaracteresEspeciais } from '../../../util/formatters/stringNormalizer';

function matches(first, second) {
  return removerCaracteresEspeciais(first)
    .toLowerCase()
    .includes(removerCaracteresEspeciais(second).toLowerCase());
}

function isEmpty(array) {
  return array.length === 0;
}

function nonNull(obj) {
  return obj !== null;
}

// {dataset, datasetFilterField, query}
export function filterByKeywords(context) {
  const { dataset, query } = context;
  const alternativas = dataset.alternativas.map((alternativa) => {
    const perguntasCorrelacionadas = alternativa.perguntasCorrelacionadas
      .map((pergunta) => {
        const matchingAlternativas = pergunta.alternativas.filter(
          (currentAlternativa) => matches(currentAlternativa.enunciado, query),
        );
        if (isEmpty(matchingAlternativas)) {
          if (matches(alternativa.enunciado, query)) {
            return pergunta;
          }
          return null;
        }
        return {
          ...pergunta,
          alternativas: matchingAlternativas,
        };
      })
      .filter((pergunta) => nonNull(pergunta));

    return {
      ...alternativa,
      perguntasCorrelacionadas,
    };
  });

  return {
    ...dataset,
    alternativas,
  };
}
